<script setup lang="ts">
import { Link, usePage } from '@inertiajs/vue3';
import BrandLogo from '@/components/marketing/shared/BrandLogo.vue';
import { home } from '@/routes';
import { show as legalPage } from '@/routes/legal';

const legalLinks = [
    { label: 'Terms of Service', slug: 'terms' },
    { label: 'Privacy Policy', slug: 'privacy' },
    { label: 'Acceptable Use Policy', slug: 'acceptable-use-policy' },
    { label: 'Cookie Policy', slug: 'cookie-policy' },
];

const productLinks = [
    { label: 'Features', href: '#features' },
    { label: 'How it works', href: '#how-it-works' },
    { label: 'AI Video Studio', href: '#video-studio' },
    { label: 'Automation controls', href: '#automation' },
    { label: 'FAQ', href: '#faq' },
];

const startLinks = [
    { label: 'Join early access', href: '#early-access' },
    { label: 'Integrations', href: '#integrations' },
];

const page = usePage();

const year = new Date().getFullYear();
</script>

<template>
    <footer class="border-border border-t">
        <div
            class="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:px-8"
        >
            <div class="flex flex-col gap-4">
                <Link :href="home()" class="w-fit">
                    <BrandLogo height="h-8" />
                    <span class="sr-only">LaunchStation home</span>
                </Link>
                <p class="text-muted-foreground max-w-xs text-sm">
                    One business, one AI marketing assistant, every channel.
                    Built for owners who are not marketers.
                </p>
            </div>

            <div class="flex flex-col gap-3">
                <p class="text-sm font-medium">Product</p>
                <a
                    v-for="link in productLinks"
                    :key="link.href"
                    :href="home().url + link.href"
                    class="text-muted-foreground hover:text-foreground text-sm transition-colors"
                >
                    {{ link.label }}
                </a>
            </div>

            <div class="flex flex-col gap-3">
                <p class="text-sm font-medium">Get started</p>
                <a
                    v-for="link in startLinks"
                    :key="link.href"
                    :href="home().url + link.href"
                    class="text-muted-foreground hover:text-foreground text-sm transition-colors"
                >
                    {{ link.label }}
                </a>
                <a
                    :href="page.props.dashboardUrl + '/sign-in'"
                    class="text-muted-foreground hover:text-foreground text-sm transition-colors"
                >
                    Sign in
                </a>
            </div>

            <div class="flex flex-col gap-3">
                <p class="text-sm font-medium">Contact</p>
                <a
                    href="mailto:hello@launchstation.app"
                    class="text-muted-foreground hover:text-foreground text-sm transition-colors"
                >
                    hello@launchstation.app
                </a>
                <p class="text-muted-foreground text-sm">
                    Early access is invite only while we finish the assistant.
                </p>
            </div>
        </div>

        <div class="border-border border-t">
            <div
                class="text-muted-foreground mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-xs sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8"
            >
                <p>© {{ year }} LaunchStation. All rights reserved.</p>
                <nav aria-label="Legal" class="flex flex-wrap gap-x-5 gap-y-2">
                    <Link
                        v-for="link in legalLinks"
                        :key="link.slug"
                        :href="legalPage(link.slug).url"
                        class="hover:text-foreground transition-colors"
                    >
                        {{ link.label }}
                    </Link>
                </nav>
            </div>
        </div>
    </footer>
</template>
